import type { FlagConfiguration } from '@atlassian/jira-flags';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	componentEditedTitle: {
		id: 'project-components.flags.component-edited-title',
		defaultMessage: '{name} updated',
		description: "Flag's title - appears when component with given {name} was updated.",
	},
});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (name: string): FlagConfiguration => ({
	type: 'success',
	isAutoDismiss: true,
	title: [messages.componentEditedTitle, { name }],
	messageId: 'project-directories.components.flags.update.flag.success',
	messageType: 'transactional',
});
